


















































































































import { PartnerEntity } from "@/models/partnerEntity";

import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class PartnerFooter extends Vue {
  @Prop()
  partnerProp?: PartnerEntity;

  @Prop()
  color?: string;

  @Prop({ default: "white" })
  fontColor?: string;

  get boxShadow() {
    return "0 50vh 0 50vh " + this.color;
  }

  get address() {
    return this.partnerProp?.address;
  }

  get settings() {
    return this.partnerProp?.settings;
  }

  get isWebsitePresent() {
    return this.settings && this.settings?.websites;
  }

  get isOpeningTimeInformationPresent() {
    return this.settings && this.settings?.openingHours;
  }
}
